import { render, staticRenderFns } from "./tabindex.vue?vue&type=template&id=eab64ca0"
import script from "./tabindex.vue?vue&type=script&lang=js"
export * from "./tabindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports